/**
 * Textarea Component Styles
 */

import { mode } from '../../system/color-mode';

export const textareaStyles = {
  baseStyle: {
    fontWeight: 400,
    borderRadius: '8px',
    minHeight: '80px',
    lineHeight: 'short',
    verticalAlign: 'top',
    width: '100%',
    outline: 0,
    position: 'relative',
    appearance: 'none',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    paddingY: '8px',
    paddingX: '12px',
  },

  sizes: {
    xs: {
      fontSize: 'xs',
      px: 2,
      py: 1,
    },
    sm: {
      fontSize: 'sm',
      px: 3,
      py: 2,
    },
    md: {
      fontSize: 'md',
      px: 4,
      py: 2,
    },
    lg: {
      fontSize: 'lg',
      px: 4,
      py: 2,
    },
  },

  variants: {
    // Outline (default)
    outline: (props) => ({
      border: '1px solid',
      borderColor: mode('gray.200', 'whiteAlpha.300')(props),
      bg: mode('white', 'whiteAlpha.100')(props),
      _hover: {
        borderColor: mode('gray.300', 'whiteAlpha.400')(props),
      },
      _focus: {
        zIndex: 1,
        borderColor: mode('brand.500', 'brand.300')(props),
        boxShadow: `0 0 0 1px ${mode('brand.500', 'brand.300')(props)}`,
      },
      _invalid: {
        borderColor: mode('red.500', 'red.300')(props),
      },
      _placeholder: {
        color: mode('gray.400', 'whiteAlpha.400')(props),
      },
    }),

    // Filled
    filled: (props) => ({
      border: '2px solid',
      borderColor: 'transparent',
      bg: mode('gray.100', 'whiteAlpha.100')(props),
      _hover: {
        bg: mode('gray.200', 'whiteAlpha.200')(props),
      },
      _focus: {
        bg: 'transparent',
        borderColor: mode('brand.500', 'brand.300')(props),
      },
      _placeholder: {
        color: mode('gray.400', 'whiteAlpha.400')(props),
      },
    }),

    // Flushed
    flushed: (props) => ({
      borderBottom: '1px solid',
      borderColor: mode('gray.200', 'whiteAlpha.300')(props),
      borderRadius: 0,
      px: 0,
      bg: 'transparent',
      _focus: {
        borderColor: mode('brand.500', 'brand.300')(props),
      },
      _placeholder: {
        color: mode('gray.400', 'whiteAlpha.400')(props),
      },
    }),

    // Unstyled
    unstyled: {
      bg: 'transparent',
      px: 0,
      py: 0,
      height: 'auto',
    },

    // ==================== PROJECT CUSTOM VARIANTS ====================

    // Main
    main: (props) => ({
      bg: mode('transparent', 'navy.800')(props),
      border: '1px solid !important',
      color: mode('secondaryGray.900', 'white')(props),
      borderColor: mode('secondaryGray.100', 'whiteAlpha.100')(props),
      borderRadius: '16px',
      fontSize: 'sm',
      p: '20px',
      _placeholder: { color: 'secondaryGray.400' },
      _focus: {
        borderColor: mode('brand.500', 'brand.400')(props),
      },
    }),

    // Auth
    auth: (props) => ({
      bg: 'white',
      border: '1px solid',
      borderColor: 'secondaryGray.100',
      borderRadius: '16px',
      _placeholder: { color: 'secondaryGray.600' },
    }),

    // Auth Secondary
    authSecondary: (props) => ({
      bg: 'white',
      border: '1px solid',
      borderColor: 'secondaryGray.100',
      borderRadius: '16px',
      _placeholder: { color: 'secondaryGray.600' },
    }),

    // Search
    search: (props) => ({
      border: 'none',
      py: '11px',
      borderRadius: 'inherit',
      _placeholder: { color: 'secondaryGray.600' },
    }),
  },

  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
};

export default textareaStyles;
